
const ReduxInitialState = {
    authentication: {
        accessToken: null,
        refreshToken: null,
    },
    lovs: {
        langauges: [],
        partnerId: 0,
    }
}

export default ReduxInitialState